import { CmsSignInForm } from '../cms/cms-sign-in-form.interface';
import { SignInFormValue } from './sign-in-form-value.type';

export interface SignInFormConfig {
  cmsData: CmsSignInForm;
  initialValue?: SignInFormValue;
}
